import { useEffect, useState } from "react";
import { Table } from "antd";

const SkeletonTable = ({
  rowKey,
  columns = [],
  data = [],
  isLoading,
  pagination = true,
  rowClassName = () => "",
  onRowClick = () => {},
  index = true,
  rowSelection,
  isCreate,
}) => {
  const [paginationConfig, setPaginationConfig] = useState({
    current: 1,
    pageSize: 10,
  });

  const [tempSelectedKeys, setTempSelectedKeys] = useState(
    rowSelection?.selectedRowKeys || []
  );

  useEffect(() => {
    setTempSelectedKeys(rowSelection?.selectedRowKeys || []);
  }, [rowSelection?.selectedRowKeys, data]);

  const numberColumn = {
    title: "No.",
    dataIndex: "no",
    render: (_, __, index) => {
      const { current, pageSize } = paginationConfig;
      return (current - 1) * pageSize + index + 1;
    },
    width: 80,
  };

  const newColumns = index ? [numberColumn, ...columns] : columns;

  const rowSelections = {
    ...(rowSelection || {}),
    selectedRowKeys: tempSelectedKeys,
    onChange: (newKeys) => {
      setTempSelectedKeys(newKeys);
      rowSelection?.onChange?.(newKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: !(isCreate === 1 && record?.is_use === 0),
    }),
  };

  return (
    <Table
      className="table-responsive"
      columns={newColumns}
      dataSource={data}
      loading={isLoading}
      sortDirections={true}
      pagination={pagination}
      rowClassName={(record) => rowClassName(record)}
      onChange={(pagination) => {
        setPaginationConfig(pagination);
      }}
      onRow={(record) => {
        return {
          onClick: () => onRowClick(record),
          style: { cursor: "pointer" },
        };
      }}
      rowSelection={rowSelection ? rowSelections : null || null}
      rowKey={rowKey || null}
    />
  );
};

export default SkeletonTable;
